import React, { useState, useRef } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster,
} from "@coreui/react";

const DeleteModal = ({
  visible,
  setVisibleDeleteModal,
  addToast,
  onConfirm,
  text,
}) => {
  const exampleToast = (
    <CToast>
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <div className="fw-bold me-auto">CoreUI for React.js</div>
        <small>7 min ago</small>
      </CToastHeader>
      <CToastBody>Hello, world! This is a toast message.</CToastBody>
    </CToast>
  );
  const closeModal = () => {
    setVisibleDeleteModal(false);
  };
  const deleteFn = () => {
    // addToast(exampleToast)
    setVisibleDeleteModal(false);
  };
  return (
    <div>
      <CModal
        visible={visible}
        onClose={() => {
          onConfirm("cancel");
        }}
      >
        <CModalHeader onClose={() => onConfirm("cancel")}>
          <CModalTitle>Confirmation Modal</CModalTitle>
        </CModalHeader>
        <CModalBody>{text ? text : "You are sure to delete this!!"}</CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => onConfirm("cancel")}>
            Close
          </CButton>
          <CButton color="danger" onClick={() => onConfirm("confirm")}>
            Confirm
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default DeleteModal;
